import { useSelector } from 'react-redux';

import { Divider, Box } from '@mui/material';
import { useTranslation } from 'next-i18next';

import CourseNotFoundSuggestionMessage from './courseNotFoundSuggestionMessage';
import CourseNotFoundWithFilterMessage from './courseNotFoundWithFilterMessage';
import Style from './style';

import { CourseApiInfiniteResponse } from 'src/api/types/courseType';
import CourseList from 'src/components/molecules/courseList';
import CourseResultHeader from 'src/components/organisms/courseResult/courseResultHeader';
import { getFirstPageCourseData } from 'src/helpers/courseApiResponse';
import { RootState } from 'src/redux/reducer';
import { ICategory } from '@interfaces/category';

type Props = {
  courseApiResponse: CourseApiInfiniteResponse;
  isShowSuggestion: boolean;
  showNumberOfCourse?: boolean;
  isSelectLearningPathCourse?: boolean;
  learningPathId?: number;
  learningPathCategory?: ICategory;
  courseCount?: number;
};

const CourseResult = ({
  courseApiResponse,
  isShowSuggestion,
  showNumberOfCourse = false,
  isSelectLearningPathCourse,
  learningPathId,
  learningPathCategory,
  courseCount,
}: Props) => {
  const { t } = useTranslation('common');
  const { courseApiQueries }: any = useSelector((state: RootState) => ({
    courseApiQueries: state.Course.get('courseApiQueries'),
  }));

  const firstPage = getFirstPageCourseData(courseApiResponse);
  const numberOfCourse = firstPage?.count ?? 0;
  const isDataNotFound = firstPage?.notFound ?? false;
  const shouldShowSuggestionBanner = isDataNotFound && isShowSuggestion;

  if (!isShowSuggestion && isDataNotFound) {
    return (
      <Style>
        <Box sx={{ my: 1, mx: 2 }}>
          <CourseResultHeader numberOfCourse={numberOfCourse} showNumberOfCourse={showNumberOfCourse} />
        </Box>
        <Divider variant="middle" sx={{ mt: { lg: 0, md: 3 } }} />
        <CourseNotFoundWithFilterMessage
          title={t('search_course.filter_course_not_found.title', { search_keyword: courseApiQueries.q })}
        />
      </Style>
    );
  }
  return (
    <Style>
      <Box sx={{ my: 1, mx: 2 }}>
        <CourseResultHeader
          numberOfCourse={numberOfCourse}
          showNumberOfCourse={showNumberOfCourse}
          isSelectLearningPathCourse={isSelectLearningPathCourse}
        />
      </Box>
      <Divider variant="middle" sx={{ mt: { lg: 0, md: 3 } }} />
      {shouldShowSuggestionBanner && <CourseNotFoundSuggestionMessage />}
      <Box
        sx={{
          mt: shouldShowSuggestionBanner ? 2 : { lg: 4, xs: 2 },
          mx: '8px',
        }}
      >
        <CourseList
          courseApiResponse={courseApiResponse}
          learningPathId={learningPathId}
          learningPathCategory={learningPathCategory}
          courseCount={courseCount}
        />
      </Box>
    </Style>
  );
};

export default CourseResult;
